import React from 'react';

type ButtonActionProps = {
    children: React.ReactNode
}

function ButtonActions(props: ButtonActionProps) {
    const {children} = props
    return (
        <div className={"molekuls-two-buttonactions"}>
            {children}
        </div>
    );
}

export default ButtonActions;
